import { useCallback, useEffect, useState } from 'react';
import { CookieConsent, OPEN_SETTINGS_EVENT, onConsentChange, readConsent, writeConsent } from '../utils/cookieConsent';

/**
 * The cookie choice as React sees it: what is on record, whether the dialog
 * shows (no choice yet, or the person asked for it again from the sidebar),
 * and the three ways to answer.
 */
export function useCookieConsent() {
  const [consent, setConsent] = useState<CookieConsent | null>(() => readConsent());
  const [open, setOpen] = useState<boolean>(() => readConsent() === null);

  useEffect(() => onConsentChange(setConsent), []);

  useEffect(() => {
    const show = () => setOpen(true);
    window.addEventListener(OPEN_SETTINGS_EVENT, show);
    return () => window.removeEventListener(OPEN_SETTINGS_EVENT, show);
  }, []);

  const decide = useCallback((preferences: boolean) => {
    writeConsent(preferences);
    setOpen(false);
  }, []);

  return {
    consent,
    open,
    acceptAll: () => decide(true),
    refuseAll: () => decide(false),
    save: decide,
  };
}
